/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useLayoutEffect } from "react";
import {
  MdArrowDropUp,
  MdArrowDropDown,
  MdKeyboardArrowRight,
} from "react-icons/md";

import { AiOutlineStar } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import explorers from "../Image/explorer.png";
import coin from "../Image/coin.png";

import { BsInfoCircle } from "react-icons/bs";
import shares from "../Image/shares.png";

import communitys from "../Image/community.png";
import websites from "../Image/website.png";
import whitepapers from "../Image/whitepaper.png";
import dollar from "../Image/dollar.png";
import Footer from "./Footer";
import stars from "../Image/stars.png";
import Navbar from "./Navbar";
import PriceChart from "./Price_Chart";
import { Tooltip } from "antd";
import { Link, useParams } from "react-router-dom";
import tick_blue from "../Image/tick_blue.png";
import toast, { Toaster } from "react-hot-toast";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import axios from "axios";
import { geckoGet } from "../../service/gecko";
import { fetchBep20Info } from "../../service/bscToken";
import Disqus from "./Disqus";

const notify = (msg) => toast.success(msg);
const notifyError = (msg) => toast.error(msg);
const notifyMessage = (msg) => toast(msg, { duration: 10000 });

const CAESER_DEXTOOLS_PAIR =
  "0xe9aad8f3af7b6d31acb6447f66fa2996237af6ed2c96143fc85503a569c79d5c";
const CAESER_TOKEN_ADDRESS = "0x6b05c841e0a3790e94d02d943ba33a3ee38bebcd";
const CAESER_BSCSCAN = "https://bscscan.com/token/" + CAESER_TOKEN_ADDRESS;
const CAESER_WEBSITE = "https://caeser.io";
const CAESER_WHITEPAPER =
  "https://docs.google.com/document/d/1KT0z_8mqKBhCqx9K-D80-cmjlgv5mNBV";
const CAESER_COMMUNITY = "https://x.com/caeser_io";
const CAESER_DEXTOOLS_URL = `https://www.dextools.io/app/bnb/pair-explorer/${CAESER_DEXTOOLS_PAIR}`;
const CAESER_LOGO = "https://i.ibb.co/Lzrpbd6r/Caeser-Red-Logo-2-copy.png";

function CAESER_Details({ url, Dissconnect, Metamask, WalletC }) {
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [project_name] = useState("CAESER");
  const [project_ticker_symbol] = useState("CSER");
  const [link_logo] = useState(CAESER_LOGO);

  const [price, setPrice] = useState(null);
  const [price24h, setPrice24h] = useState(null);
  const [volume24h, setVolume24h] = useState(null);
  const [market_cap, setMarketCap] = useState(null);
  const [circulating_supply, setCirculatingSupply] = useState(100000000);
  const [total_supply, setTotalSupply] = useState(500000000);

  const [coinPrice, setCoinPrice] = useState("");
  const [usdValue, setUsdValue] = useState("");

  const [highlight, sethighlight] = useState("light-theme");
  const [base, setbase] = useState("light-theme");
  const [theme, setTheme] = useState("");

  useLayoutEffect(() => {
    const data = window.localStorage.getItem("theme");
    if (data === "dark-theme") {
      sethighlight("#444");
      setbase("#202020");
      setTheme("dark");
    } else {
      sethighlight("#d1d1d1");
      setbase("#efecec");
      setTheme("light");
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // GeckoTerminal: free, no API key, CORS-friendly
        const res = await geckoGet(
          `https://api.geckoterminal.com/api/v2/networks/bsc/tokens/${CAESER_TOKEN_ADDRESS}/pools?page=1`,
          { headers: { Accept: "application/json;version=20230302" } },
        );
        const pools = res.data?.data;
        if (pools && pools.length > 0) {
          const attrs = pools[0].attributes;
          const livePrice = parseFloat(attrs.base_token_price_usd) || 0;
          const liveChange =
            parseFloat(attrs.price_change_percentage?.h24) || 0;
          const vol = parseFloat(attrs.volume_usd?.h24) || 0;
          const mcap =
            parseFloat(attrs.market_cap_usd) ||
            parseFloat(attrs.fdv_usd) ||
            parseFloat(attrs.reserve_in_usd) * 2 ||
            0;
          setPrice(livePrice);
          setPrice24h(liveChange);
          setVolume24h(vol);
          setMarketCap(mcap);
        }
      } catch (err) {
        console.error("Error fetching CAESER data:", err);
      }
    };
    fetchData();
  }, []);

  // Total supply straight from the contract (Ankr BSC RPC)
  useEffect(() => {
    fetchBep20Info(CAESER_TOKEN_ADDRESS).then((info) => {
      if (info?.totalSupply > 0) {
        setTotalSupply(info.totalSupply);
      }
    });
  }, []);

  const handleCoinPriceChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setCoinPrice(val);
    setUsdValue(val * (price || 0));
  };

  const handleUsdValueChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setUsdValue(val);
    setCoinPrice(price ? val / price : 0);
  };

  const copyTextToClipboard = (text) => {
    notify("copied");
    return navigator.clipboard.writeText(`${text}`);
  };

  const addrString = localStorage.getItem("address");
  let addr = null;
  if (addrString !== null) {
    try {
      addr = JSON.parse(addrString);
    } catch (_) {}
  }

  const handleSubmitnft_watchlist = () => {
    notifyMessage("Please log in to use the watchlist.");
  };

  const delete_watchlist = () => {
    notifyMessage("Please log in to use the watchlist.");
  };

  const [watchlist_star] = useState(false);

  const Market_Cap_tooltip = (
    <div className="p-y-1">
      <div className="m-b-1">
        The total market value of a cryptocurrency's circulating supply. It is
        analogous to the free-float capitalization in the stock market.
      </div>
      <div>Market cap = Current price x Circulating supply</div>
    </div>
  );

  const volume_market_tooltip = (
    <div className="p-y-1">
      <div className="m-b-1">
        Indicator of liquidity. The higher the ratio, the more liquid the
        cryptocurrency is.
      </div>
      <div>
        Cryptocurrencies with a low ratio are less liquid and most likely
        present less stable markets.
      </div>
    </div>
  );

  const fmt = (n, min = 2, max = 6) =>
    n !== null && n !== undefined
      ? Number(n).toLocaleString("en-US", {
          minimumFractionDigits: min,
          maximumFractionDigits: max,
        })
      : null;

  return (
    <>
      <SkeletonTheme baseColor={base} highlightColor={highlight}>
        <Navbar
          Dissconnect={Dissconnect}
          Metamask={Metamask}
          WalletC={WalletC}
        />
        <Toaster />

        <div className="container-kws">
          <div className="m-t-2">
            <span>
              <Link to="/">
                Cryptocurrencies <MdKeyboardArrowRight />
                {project_name}
              </Link>
            </span>{" "}
            <span>
              <MdKeyboardArrowRight /> {project_ticker_symbol}
            </span>
          </div>

          <div className="row">
            {/* Left column — logo + links */}
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 m-y-1 f-w-i">
              <div className="d-f a-i-c flex-wrap f-w-i">
                <img
                  src={link_logo}
                  alt="CAESER logo"
                  className="m-r-1 w-3 h-3 b-r-50 m-y-1"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/60?text=C";
                  }}
                />
                <div className="f-w-600 f-s-2 m-r-1 m-y-1">{project_name}</div>

                <Tooltip title="Verified">
                  <span>
                    <button className="b-c-t b-n m-r-1 m-y-1">
                      <img src={tick_blue} className="w-1_5" />
                    </button>
                  </span>
                </Tooltip>

                <button className="bg_g_clr clr pa-5px b-r-5 b-n f-w-600 m-r-1 m-y-1">
                  {project_ticker_symbol}
                </button>

                {addr ? (
                  watchlist_star ? (
                    <Tooltip title="Remove from watchlist">
                      <span>
                        <button
                          className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                          onClick={delete_watchlist}
                        >
                          <img src={stars} className="w-1_5" />
                        </button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Add to watchlist">
                      <span>
                        <button
                          className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                          onClick={handleSubmitnft_watchlist}
                        >
                          <AiOutlineStar className="b-c-t f-s-18px" />
                        </button>
                      </span>
                    </Tooltip>
                  )
                ) : (
                  <button
                    className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                    onClick={() => notifyError("You are not logged in!")}
                  >
                    <AiOutlineStar className="b-c-t f-s-18px" />
                  </button>
                )}

                <Tooltip title="Share">
                  <span>
                    <button
                      className="bg_g_clr pa-5px b-r-5 b-n f-w-600 bg_g_clr_btn c-p m-r-1 m-y-1"
                      onClick={handleShow2}
                    >
                      <img src={shares} className="b-c-t w-1_5" />
                    </button>
                  </span>
                </Tooltip>

                <div className="bg_g_clr pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                  <img src={coin} className="w-1_5" />
                  &nbsp;Coin
                </div>

                {/* Website */}
                <a href={CAESER_WEBSITE} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={websites} className="w-1_5" />
                    &nbsp;Website
                  </div>
                </a>

                {/* Explorer */}
                <a href={CAESER_BSCSCAN} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={explorers} className="w-1_5" />
                    &nbsp;Explorers
                  </div>
                </a>

                {/* Community */}
                <a href={CAESER_COMMUNITY} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={communitys} className="w-1_5" />
                    &nbsp;Community
                  </div>
                </a>

                {/* Whitepaper */}
                <a href={CAESER_WHITEPAPER} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    <img src={whitepapers} className="w-1_5" />
                    &nbsp;Whitepaper
                  </div>
                </a>

                {/* DexTools */}
                <a href={CAESER_DEXTOOLS_URL} rel="noreferrer" target="_blank">
                  <div className="bg_g_clr bg_g_clr_btn pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                    &nbsp;DexTools
                  </div>
                </a>

                <div className=" bg_g_clr pa-5px b-r-5 w-s-n-w m-r-1 m-y-0_5 d-f a-i-c">
                  31-03-2026
                </div>
              </div>
            </div>

            {/* Right column — price stats */}
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 m-y-1">
              <div className="m-t-1">
                {project_name} ({project_ticker_symbol})
              </div>
              <div className="d-f a-i-c m-t-0_5">
                <div className="m-r-1 f-s-2 f-w-600">
                  {price !== null ? (
                    `$ ${fmt(price, 6, 8)}`
                  ) : (
                    <Skeleton className="w-7" />
                  )}
                </div>
                {price24h !== null && (
                  <div className={price24h >= 0 ? "green_clr" : "red_clr"}>
                    {price24h >= 0 ? (
                      <MdArrowDropUp className="b-c-t green_f_clr" />
                    ) : (
                      <MdArrowDropDown className="b-c-t red_f_clr" />
                    )}
                    {Number(price24h).toFixed(2)}%
                  </div>
                )}
              </div>
              <hr />
              <div className="row">
                {/* Market Cap */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Market Cap &nbsp;
                    <Tooltip title={Market_Cap_tooltip}>
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {market_cap !== null && market_cap > 0 ? (
                      `$ ${fmt(market_cap, 0, 0)}`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>

                {/* 24h Vol / Mkt Cap */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    24h Vol / Mkt Cap &nbsp;
                    <Tooltip title={volume_market_tooltip}>
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                    <div className="m-t-1">
                      {market_cap && volume24h && market_cap > 0
                        ? `${((volume24h / market_cap) * 100).toFixed(2)}%`
                        : "N/A"}
                    </div>
                  </div>
                </div>

                {/* 24h Volume */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1">
                  <div className="m-b-1">
                    24h Volume &nbsp;
                    <Tooltip title="A measure of how much of a cryptocurrency was traded in the last 24 hours.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {volume24h !== null && volume24h > 0
                      ? `$ ${fmt(volume24h, 0, 0)}`
                      : "N/A"}
                  </div>
                </div>

                <hr />

                {/* Circulating Supply */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Circulating Supply &nbsp;
                    <Tooltip title="The amount of coins that are circulating in the market and are in public hands.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {circulating_supply !== null && circulating_supply > 0 ? (
                      `${fmt(circulating_supply, 0, 0)} CSER`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>

                {/* FDV */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1 b-r_1">
                  <div className="m-b-1">
                    Fully Diluted Valuation &nbsp;
                    <Tooltip title="FDV = Current Price x Total Supply">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {total_supply !== null &&
                    price !== null &&
                    total_supply > 0 &&
                    price > 0 ? (
                      `$ ${fmt(total_supply * price, 0, 0)}`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>

                {/* Total Supply */}
                <div className="col-12 col-sm-12 col-md-4 m-b-1">
                  <div className="m-b-1">
                    Total Supply &nbsp;
                    <Tooltip title="The amount of coins that have already been created, minus any coins that have been burned.">
                      <span>
                        <BsInfoCircle />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="m-b-1">
                    {total_supply !== null && total_supply > 0 ? (
                      `${fmt(total_supply, 0, 0)} CSER`
                    ) : (
                      <Skeleton className="w-5" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="container-kws">
          <div className="d-f flex-wrap a-i-c p-y-1">
            <div className="m-r-1 bg_b_clr pa-5px b-r-5 c-w">Overview</div>
          </div>
        </div>
        <hr />

        <div className="container-kws">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-8 m-y-1">
              <PriceChart
                api={null}
                staticPrice={price || 0}
                staticTotalSupply={total_supply || 0}
              />

              {/* Converter */}
              <div className="m-t-3 m-b-3">
                <div className="">{project_ticker_symbol} to USD Converter</div>
                <div className="bg_violet b-r-15">
                  <div className="row a-i-c m-t-1 pa-2 p-y-2">
                    <div className="col">
                      <div className="d-f a-i-c w-100">
                        <img
                          src={link_logo}
                          className="w-2 h-2 b-r-50 m-r-1"
                          alt=""
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/40?text=C";
                          }}
                        />
                        <div className="f-s-0_8 w-100">
                          <input
                            type="text"
                            className="b-n pa-0_5 w-100 b-r-5"
                            placeholder="Enter amount"
                            value={coinPrice}
                            onChange={handleCoinPriceChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="d-f a-i-c w-100">
                        <img
                          src={dollar}
                          className="w-2 h-2 b-r-50 m-r-1"
                          alt=""
                        />
                        <div className="f-s-0_8 w-100">
                          <input
                            type="text"
                            className="b-n pa-0_5 w-100 b-r-5"
                            placeholder="USD value"
                            value={usdValue}
                            onChange={handleUsdValueChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* About section */}
              <div className="m-t-3 m-b-3">
                <div className="f-w-600 f-s-1_5 m-b-1">About CAESER</div>
                <p>
                  CAESER is a BEP-20 token deployed on Binance Smart Chain
                  (BSC). Visit{" "}
                  <a href={CAESER_WEBSITE} target="_blank" rel="noreferrer">
                    {CAESER_WEBSITE}
                  </a>{" "}
                  for more information, or read the{" "}
                  <a href={CAESER_WHITEPAPER} target="_blank" rel="noreferrer">
                    whitepaper
                  </a>
                  .
                </p>
                <div className="m-t-1">
                  <strong>Contract Address:</strong>{" "}
                  <a href={CAESER_BSCSCAN} target="_blank" rel="noreferrer">
                    {CAESER_TOKEN_ADDRESS}
                  </a>{" "}
                  <button
                    className="b-c-t b-n c-p"
                    onClick={() => copyTextToClipboard(CAESER_TOKEN_ADDRESS)}
                  >
                    📋
                  </button>
                </div>
                <div className="m-t-1">
                  <strong>Blockchain:</strong> Binance Smart Chain (BEP-20)
                </div>
                <div className="m-t-1">
                  <strong>Community:</strong>{" "}
                  <a href={CAESER_COMMUNITY} target="_blank" rel="noreferrer">
                    @caeser_io on X (Twitter)
                  </a>
                </div>
              </div>

              <Disqus />
            </div>

            {/* Right sidebar */}
            <div className="col-12 col-sm-12 col-md-4 m-y-1">
              <div
                className="pa-1 b-r-10"
                style={{ border: "1px solid #e0e0e0" }}
              >
                <div className="f-w-600 m-b-1">CAESER Info</div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Website</span>
                  <a href={CAESER_WEBSITE} target="_blank" rel="noreferrer">
                    caeser.io
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Community</span>
                  <a href={CAESER_COMMUNITY} target="_blank" rel="noreferrer">
                    @caeser_io
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Explorer</span>
                  <a href={CAESER_BSCSCAN} target="_blank" rel="noreferrer">
                    BscScan
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Whitepaper</span>
                  <a href={CAESER_WHITEPAPER} target="_blank" rel="noreferrer">
                    View PDF
                  </a>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>DexTools</span>
                  <a
                    href={CAESER_DEXTOOLS_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Pair Explorer
                  </a>
                </div>
                <hr />
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Chain</span>
                  <span>BEP-20 (BSC)</span>
                </div>
                <div className="d-f j-c-s-b m-b-0_5">
                  <span>Contract</span>
                  <Tooltip title={CAESER_TOKEN_ADDRESS}>
                    <span
                      className="c-p"
                      style={{
                        maxWidth: 120,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                      }}
                      onClick={() => copyTextToClipboard(CAESER_TOKEN_ADDRESS)}
                    >
                      {CAESER_TOKEN_ADDRESS.slice(0, 8)}...
                      {CAESER_TOKEN_ADDRESS.slice(-6)}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </SkeletonTheme>

      {/* Share Modal */}
      <Modal show={show2} onHide={handleClose2} centered>
        <Modal.Body>
          <div className="f-w-600 m-b-1">Share CAESER</div>
          <div className="d-f a-i-c">
            <input
              className="b-n pa-0_5 w-100 b-r-5"
              style={{ border: "1px solid #ccc" }}
              readOnly
              value={window.location.href}
            />
            <button
              className="b-c-t b-n c-p m-l-1"
              onClick={() => {
                copyTextToClipboard(window.location.href);
                handleClose2();
              }}
            >
              📋 Copy
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CAESER_Details;
